import { Flex, Text } from '@chakra-ui/react';

interface IAddressCardProps {
  city: string;
  state: string;
  street: string;
  district: string;
  number: string;
  complement?: string;
}

export function AddressCard({
  city,
  state,
  street,
  district,
  number,
  complement,
}: IAddressCardProps) {
  return (
    <Flex
      flexDir="column"
      borderRadius="lg"
      p={4}
      bg="brand.50"
      border="1px solid"
      borderColor="neutral.400"
    >
      <Flex
        flexDir={{ base: 'column-reverse', lg: 'row' }}
        justifyContent={{ lg: 'space-between' }}
        alignItems={{ base: 'start', lg: 'center' }}
        mb={4}
      >
        <Text color="brand.800" fontSize="lg" fontWeight="semibold">
          {city} - {state}
        </Text>
      </Flex>

      <Text color="brand.800" fontSize="sm" fontWeight="medium">
        {street}, {number} - {district}
        {complement && ` - ${complement}`}
      </Text>
    </Flex>
  );
}
